import Trends from './Trends';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AssetAction from '../../modules/actions/AssetAction';

const mapStateToProps = (state) => ({
  assetList: state.AssetReducer.ASSET_DEVICE_LIST,
  deviceCache: state.AssetReducer.deviceCache,
  deviceList: state.DeviceReducer.allDeviceList,
  deviceTypeList: state.DeviceTypeReducer.deviceTypeList
});

const mapDispatchToProps = (dispatch) => {
  return {
    AssetAction: bindActionCreators(AssetAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Trends);
